<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button type="button" id="cancelTrainingEmailManagerAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- Location -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="location" name="location"
                                    placeholder="Select Location"
                                    :options="locationArr" :clearable=false
                                    @input="locationError=''">
                                </v-select>
                                <div class="help is-danger">{{locationError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Department -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Department :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="department" name="department"
                                    label="text"
                                    :options="departmentArr" :clearable=false placeholder="Select Department"
                                    @input="departmentError=''">
                                </v-select>
                                <div class="help is-danger">{{departmentError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- To Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">To Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <vue-tags-input
                                    v-model="toEmail"
                                    :tags="toEmailTagsArr"
                                    :validation="validation"
                                    @tags-changed="handleToEmlTagsChanged"
                                    @before-adding-tag="checkToEmailTag"
                                    placeholder=""
                                    @input="toEmailError=''"
                                />
                                <div class="help is-danger">{{toEmailError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- CC Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">CC Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <!-- <input type="text" maxlength="190" class="form-control" v-model="ccEmail" id="ccEmail" placeholder="Enter CC Email" name="ccEmail"> -->
                                <!--<input @input="emailError = ''" id="email" v-model="email" class="form-control" type="text"/>-->
                                <vue-tags-input
                                    v-model="ccEmail"
                                    :tags="ccEmailTagsArr"
                                    :validation="validation"
                                    @tags-changed="newTags => ccEmailTagsArr = newTags"
                                    @before-adding-tag="checkCCEmailTag"
                                    placeholder=""
                                />
                                <div class="help is-danger">{{ccEmailError}}</div>
                                <!-- <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                        <div class="col-12 forms-block" v-if="location.name == 'All'">
                            <span class="text-danger">NOTE: Selected email address will get the summary report as an executive.</span>
                        </div>
                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button type="button" id="cancelTrainingEmailManagerAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addEmailManagerData('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addEmailManagerData('save')"><span id="createTrainingEmailManager">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPVELOCITY} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from "../event-bus";
    import VueTagsInput from '@johmun/vue-tags-input';
    import {getHeader} from "../../config";

    var self;
    Vue.component('v-select', vSelect);
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateTrainingEmailManager',
        mixins: [commonMixins],
        components: {
            VueTagsInput,
        },
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Top Facility Email Manager',
                edit_id: 0,
                toEmail:"",
                ccEmail: "",
                toEmailTagsArr:[],
                ccEmailTagsArr: [],
                validation: [{
                    classes: 'valid-email',
                    rule: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                }],
                isValidToEmailTag :true,
                isValidCCEmailTag : true,
                toEmailError:"",
                ccEmailError: "",
                departmentArr: [],
                department: "",
                departmentError: "",
                location: [],
                locationArr: [],
                locationError: "",
                loginUserRoleId: 1,
                bodyShopLocationArr: [],
                serviceLocationArr: [],
                locationArr: [],
                permissionsArray: ['access_form_email_manager'],
                laborReviewLocationArr: [],
                old_location_id: 0,
                old_dept_id: 0,
                location_api_in_process:0,
                department_api_in_process:0,
                isFormType: 'top_facility_export',
                isToEmailTagEmpty: true
            }
        },
        watch: {
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
          //  self.loadFormMasterData();
            self.setActiveMenu("training-email-manager");
            EventBus.$emit("menu-selection-changed", "training-email-manager");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
              //  self.loginUserRoleId = userJson['role'].system_id;
            }
            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit Top Facility Email Manager';
                    self.getTrainingEmailManagerDataById();
                    $("#createTrainingEmailManager").html("Update");
                }
            });
            // self.loadBodyShopLocation();
            self.location_api_in_process=1;
            self.department_api_in_process=1;
            self.loadLocation();
            self.loadDepartmentData();
        },
        methods: {
            buttonBack() {
                self.$router.push('/training-email-manager');
            },
            checkToEmailTag: function(obj) {
                self.toEmailError = "";
                self.isToEmailTagEmpty = false;
                self.isValidToEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!tagEmail[1]) {
                    self.isToEmailTagEmpty = true;
                } else if(tagEmail[1] && !self.validEmail(tagEmail[1])) {
                    self.isValidToEmailTag = false;
                } else obj.addTag();
            },
            handleToEmlTagsChanged: function(newTags) {
                self.toEmailTagsArr = newTags; // Update the tags array

                self.toEmailError = "";
                self.isToEmailTagEmpty = false;
                self.isValidToEmailTag = true;

                // Check if there are empty or invalid tags after tag change
                if (self.toEmailTagsArr.length === 0) {
                    self.isToEmailTagEmpty = true;
                } else {
                    // Check for invalid email tags
                    let invalidTagFound = self.toEmailTagsArr.some(tag => !self.validEmail(tag.text));
                    if (invalidTagFound) {
                        self.isValidToEmailTag = false; // It's not empty but has invalid email(s)
                    }
                }
            },
            checkCCEmailTag: function(obj) {
                self.ccEmailError = "";
                self.isValidCCEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!self.validEmail(tagEmail[1])) {
                    self.isValidCCEmailTag = false;
                    self.ccEmailError = "Please enter valid CC Email";
                } else obj.addTag();
            },
            getTrainingEmailManagerDataById: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: self.edit_id,
                    }
                };
                self.showLoader();
                HTTP.get("/email/manager/getbyid", config)
                    .then(function (response) {
                        setTimeout(function() {
                            self.location=({"name": response.data.content.location, "label": response.data.content.location/* +"("+response.data.content.location_id+")" */, "id": response.data.content.location_id/* , "excede_location_id": response.data.content.location_id */});
                            var selectedLocation = { id: response.data.content.location_id };
                            if(response.data.content.department && response.data.content.department_id) {
                                self.department=({"text": response.data.content.department/* +"("+response.data.content.department_id+")" */, "label":response.data.content.department, "value": response.data.content.department_id});
                            }
                            self.loadDepartmentData(selectedLocation);
                            self.hideLoader();
                        }, 50);
                        if(response.data.content.location && response.data.content.location_id) {
                            self.old_location_id=response.data.content.location_id;
                        }
                        if(response.data.content.department && response.data.content.department_id) {
                            self.old_dept_id=response.data.content.department_id;
                        }
                        if(response.data.content.cc_email && response.data.content.cc_email != 'NULL') {
                            var ccEmailArr = response.data.content.cc_email.split(",");
                            for(var index = 0; index < ccEmailArr.length; index++) {
                                self.ccEmailTagsArr.push({"text": ccEmailArr[index], "tiClasses": ["ti-valid"]});
                            }
                        }
                        if(response.data.content.to_email && response.data.content.to_email != 'NULL') {
                            var toEmailArr = response.data.content.to_email.split(",");
                            for(var index = 0; index < toEmailArr.length; index++) {
                                self.toEmailTagsArr.push({"text": toEmailArr[index], "tiClasses": ["ti-valid"]});
                            }
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            loadDepartmentData: function(location) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        form_type: self.isFormType,
                    }
                };
                HTTP.get('/department/manager/getall', config)
                    .then(function (response) {
                        self.department_api_in_process=0;
                        if(response && response.data) {
                            self.departmentArr = response.data.content;
                            self.departmentArr = self.departmentArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            self.departmentArr.forEach(element => {
                                // self.departmentArr.push({'text' : element.name+"("+element.excede_department_id+")", 'label':element.name, 'value' : element.excede_department_id});
                                element.text = element.name/* +"("+element.excede_department_id+")" */;
                                element.value=element.id;
                                element.label=element.name;
                            });
                            if(self.location_api_in_process==0) {
                                self.hideLoader();
                            }
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                        self.hideLoader();
                    });
            },
            loadLocation: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        form_type: self.isFormType,
                    }
                };
                self.showLoader();
                HTTP.get("/location/manager/getall", config)
                        .then(function (response) {
                            self.location_api_in_process=0;
                            self.locationArr = response.data.content;
                            self.locationArr = self.locationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            self.locationArr.forEach(element => {
                                element.label=element.name/* +"("+element.excede_location_id+")" */;
                                element.value=element.id;
                            });
                            if(self.department_api_in_process==0) {
                                self.hideLoader();
                            }
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                self.locationError = "";
                self.departmentError = "";
                self.toEmailError = "";
                self.ccEmailError = "";
                self.isValidCCEmailTag = true;
                if (self.location.length == 0) {
                    self.locationError = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.department.length == 0) {
                    self.departmentError = "select Department";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.isToEmailTagEmpty) {
                    self.toEmailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.isValidToEmailTag) {
                    self.toEmailError = "Please enter valid email";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addEmailManagerData(flag) {
                setTimeout(() => {
                    if (self.checkForm() && self.isValidCCEmailTag && self.isValidToEmailTag) {
                        var toEmailData = "";
                        if(self.toEmailTagsArr && self.toEmailTagsArr.length > 0) {
                            for(var index = 0;index<self.toEmailTagsArr.length;index++) {
                                if(!toEmailData.includes(self.toEmailTagsArr[index].text)) {
                                    toEmailData += (self.toEmailTagsArr[index].text) + ',';
                                }
                            }
                            toEmailData = toEmailData.replace(/,\s*$/, "");
                        }
                        var ccEmailData = "";
                        if(self.ccEmailTagsArr && self.ccEmailTagsArr.length > 0) {
                            for(var index = 0;index<self.ccEmailTagsArr.length;index++) {
                                if(!ccEmailData.includes(self.ccEmailTagsArr[index].text)) {
                                    ccEmailData += (self.ccEmailTagsArr[index].text) + ',';
                                }
                            }
                            ccEmailData = ccEmailData.replace(/,\s*$/, "");
                        }
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        };
                        let deptName="", deptId=0;
                        if(self.department) {
                            deptName=self.department.label;
                            deptId=self.department.value;
                        }
                        var user = JSON.parse(localStorage.getItem('user_obj'));
                        var login_userid=0;
                        if(user) {
                            login_userid=user.emp_id;
                        }
                        var fields = {
                            id: self.edit_id,
                            location: self.location.id,
                            location_name: self.location.name,
                            department:deptId,
                            department_name:deptName,
                            to_email: toEmailData,
                            cc_email: ccEmailData,
                            old_location_id: self.old_location_id,
                            old_dept_id: self.old_dept_id,
                            userid: login_userid,
                            form_type: self.isFormType
                        };
                        self.showLoader();
                        HTTP.post("/email/manager/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if (flag == 'save') {
                                        self.buttonBack();
                                    } else {                                        
                                        self.clearDataSaveAndContinue();
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearDataSaveAndContinue: function() {
                self.edit_id = 0;
                self.department = '';
                self.location = '';
                self.toEmail = '';
                self.ccEmail = '';
                self.toEmailTagsArr = [];
                self.ccEmailTagsArr = [];
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/TrainingEmailManager/AddUpdateTrainingEmailManager.vue